window.onload = (event) => {
  var waves = new SineWaves({
    el: document.getElementById('waves'),
    
    
    speed: 2,
    
    ease: 'SineInOut',
    
    wavesWidth: '225%', 

    rotate: 5,
    
    waves: randomWavesArray,

    resizeEvent: function() {
      var gradient = this.ctx.createLinearGradient(0, this.height, this.width, 0);
      gradient.addColorStop(0,"#F7F7F7");
      
      var index = -1;
      var length = this.waves.length;
        while(++index < length){
        this.waves[index].strokeStyle = gradient;
      }
      
      // Clean Up
      index = void 0;
      length = void 0;
      gradient = void 0;
    },
  });
  $('#waves').css('opacity','1');
};

function generateRandomWaves(count) {
  var wavesArray = [];

  for (var i = 0; i < count; i++) {
      var randomWave = {
          timeModifier: getRandomFloat(1.5, 2), // Adjust the range as needed
          lineWidth: 1,
          amplitude: getRandomInt(0, 100),     // Adjust the range as needed
          wavelength: getRandomInt(100, 500),  // Adjust the range as needed
      };

      wavesArray.push(randomWave);
  }

  return wavesArray;
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getRandomFloat(min, max) {
  return Math.random() * (max - min) + min;
}

// Example: Generate an array with 10 random waves
var userInputCount = 15;
var randomWavesArray = generateRandomWaves(userInputCount);

